var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"aki-btn",class:[
    ("aki-btn-" + _vm.type),
    ("aki-btn-" + _vm.size),
    {'aki-btn-round': _vm.round},
    {'aki-btn-circle': _vm.circle},
    {'aki-btn-full-width': _vm.full},
    {'aki-btn-plain': _vm.plain},
    {'aki-btn-loading': _vm.loading},
    {'aki-badge': _vm.badge !== false},
    {'aki-badge-dot':_vm.badge===true} ],attrs:{"badge":_vm.badge},on:{"click":_vm.click}},[(_vm.loading)?_c('aki-progress',{attrs:{"width":"24","stroke":"2","loading":""}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }